import { minMaxFromContainer, availabilityBoundsFromContainer } from './date-range';

/** Auto-fill CheckIn/CheckOut (value + min/max bounds) from the selected accommodation pickers. */
export function syncContractDatesFromAccommodation(
    pricesContainer: HTMLElement,
    checkInInput: HTMLInputElement | null,
    checkOutInput: HTMLInputElement | null
): void {
    if (!pricesContainer.querySelector('.sub-range-from-picker')) return;

    const { min: boundMin, max: boundMax } = availabilityBoundsFromContainer(pricesContainer);
    const { min: selMin,   max: selMax }   = minMaxFromContainer(pricesContainer);

    for (const input of [checkInInput, checkOutInput]) {
        if (!input) continue;
        if (boundMin) input.min = boundMin; else input.removeAttribute('min');
        if (boundMax) input.max = boundMax; else input.removeAttribute('max');
    }
    if (checkInInput  && selMin) { checkInInput.value  = selMin;  checkInInput.dispatchEvent(new Event('change')); }
    if (checkOutInput && selMax) { checkOutInput.value = selMax; checkOutInput.dispatchEvent(new Event('change')); }
}
